<template>
  <div>
    <Head :title="title" />
    <div class="max-w-2xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pb-8 pr-6 w-full"
            :label="__('Name')"
          />
          <div class="pb-8 pr-6 w-full">
            <label class="form-label">{{ __('Description') }}</label>
            <textarea
              v-model="form.description"
              class="form-input w-full"
              rows="3"
            />
            <div v-if="form.errors.description" class="form-error">{{ form.errors.description }}</div>
          </div>
          <div class="pb-8 pr-6 w-full flex items-center gap-3">
            <label class="form-label mb-0">{{ __('Active') }}</label>
            <input v-model="form.active" type="checkbox" class="w-5 h-5 cursor-pointer" />
          </div>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button
            class="text-red-600 hover:underline"
            tabindex="-1"
            type="button"
            @click="destroy"
          >
            {{ __('Delete') }}
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ __('Update Product') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  name: 'ServiceEdit',
  components: { Head, LoadingButton, TextInput },
  layout: Layout,
  props: {
    service: Object,
    title: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.service.name,
        description: this.service.description,
        active: this.service.active,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(this.route('services.update', this.service.id))
    },
    destroy() {
      if (confirm(this.__('Are you sure you want to delete this service?'))) {
        this.$inertia.delete(this.route('services.destroy', this.service.id))
      }
    },
  },
}
</script>
